import { supabase } from "../lib/supabaseClient";
import { MachineRow } from "../types/operations";

// =============================================
// Raw shape returned by Supabase for a machines
// row before mapping to the domain type.
// =============================================
interface RawMachineRow {
  id: string;
  type: string;
  number: number;
}

// =============================================
// Fetch every row from the machines reference
// table. This is called once per upload to build
// an in-memory lookup map for machine_id resolution.
// =============================================
export async function fetchAllMachines(): Promise<MachineRow[]> {
  const { data, error } = await supabase
    .from("machines")
    .select("id, type, number");

  if (error) {
    throw new Error(`Failed to fetch machines: ${error.message}`);
  }

  if (!data) {
    return [];
  }

  return (data as RawMachineRow[]).map((row) => ({
    id: row.id,
    type: row.type,
    number: row.number,
  }));
}
